module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point04_06_activity-698ffa7140596ab2a84ee7c0a1177cdf.jpg";